<div class="rounded-3 h-100 p-2 bg-trocar-produto text-center">
  <img [src]="getSanitizedImageSrc(imagemProduto) ?? './assets/images/seriella-produto-default.png'"  [ngStyle]="{ width: '200px' }" />
  <p>{{produtoSelecionado?.descricao}}</p>
  <div class="col-12 mt-3">
    <a class="text-white text-decoration-underline link-hover" (click)="showModal()">Trocar Produto</a>
  </div>
  <nz-modal [(nzVisible)]="isVisible" [nzTitle]="!this.produtoSelecionado ? 'Escolha o Produto' : 'Trocar produto'" [nzCloseIcon]="'false'">
  <ng-container *nzModalContent>
    <p>{{ !this.produtoSelecionado ? 'Selecione o produto:' : 'Selecione o novo produto:' }} </p>
    <nz-select [(ngModel)]="itemSelecionado">
      <nz-option [nzValue]="item" [nzLabel]="item.descricao" *ngFor="let item of listaProdutos"></nz-option>
    </nz-select>
    <br/>
  </ng-container>
  <ng-container *nzModalFooter>
    <div class="row d-flex justify-content-end my-2 mx-2 g-2">
      <div class="col-4">
        <button nz-button nzType="default" type="button" nzSize="large" class="d-flex justify-content-center fw-semibold rounded-3 w-100 fs-6" [disabled]="!this.produtoSelecionado" (click)="handleCancel()">
          Voltar
        </button>
      </div>
      <div class="col-3">
        <button nz-button nzType="primary" type="button" nzSize="large" class="d-flex justify-content-center fw-semibold rounded-3 w-100 fs-6 btn-primary-color'" [disabled]="!itemSelecionado" (click)="handleOk()">
          Salvar
        </button>
      </div>
    </div>
  </ng-container>
</nz-modal>
</div>
